import { useEffect, useState } from "react";

const reviewOptions = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "this_week", label: "This Week" },
    { value: "last_week", label: "Last Week" },
    { value: "this_month", label: "This Month" },
    { value: "last_month", label: "Last Month" },
    { value: "last_sixty_days", label: "Last 60 Days", disabled: true },
    { value: "this_year", label: "This Year", disabled: true },
  ];
  
export const REVIEW_DEFAULT_OPTION = "this_month";

const ReviewInsightsList = ({
    insights,
    onOptionChange,
  }) => {
    const [timeframe, setTimeframe] = useState(REVIEW_DEFAULT_OPTION);

    const loading = insights === null || insights.timeFrame !== timeframe;

    const selectedTimeframe = reviewOptions?.find(option => option.value === timeframe)?.label?.toLowerCase();
    const insightsList = insights?.getSortedBySeverity() ?? [];
  
    const insightsListJsx = insightsList.map((insight, index) => (
      <div key={index} className="mt-2">
        <div>
          <strong>{insight.issueTitle}</strong>: {insight.summary}
        </div>
        <div className="affected-header">Affected business:</div>
        <ul>
          {insight.locations.map((location, locIndex) => (
            <li key={locIndex}>{location}</li>
          ))}
        </ul>
      </div>
    ));

    useEffect(() => {
      if(!loading) {
        onOptionChange(timeframe);
      }
    }, [timeframe]);
  
    return (
      <div className="insights-container">
        
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              marginBottom: "20px",
              height: "40px",
            }}
          >
            <div className="sub-title">Review insights for {selectedTimeframe}</div>
            <select
              className="form-select"
              style={{ width: "150px" }}
              onChange={(e) => setTimeframe(e.target.value)}
              disabled={loading} 
            >
              {reviewOptions.map((option, index) => (
                <option
                  key={index}
                  value={option.value}
                  selected={option.value === timeframe}
                  disabled={option?.disabled ?? false}
                >
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        
        {loading ? ( 
          <div className="shimmer-container">
            <div className="shimmer" style={{ width: "100%" }}></div>
            <div className="shimmer" style={{ width: "60%" }}></div>
            <div className="shimmer" style={{ width: "100%" }}></div>
            <div className="shimmer" style={{ width: "60%" }}></div>
            <div className="shimmer" style={{ width: "100%" }}></div>
            <div className="shimmer" style={{ width: "60%" }}></div>
          </div>
        ) : insightsList.length > 0 ? (
          insightsListJsx
        ) : (
          <div className="fs-6 text-muted">No insights available</div>
        )}
      </div>
    );
  };
  
  export default ReviewInsightsList;
  